var reduceReducers = function () {
    var reducers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        reducers[_i] = arguments[_i];
    }
    return function (state, action) { return (reducers.reduce(function (acc, nextReducer) { return nextReducer(acc, action); }, state)); };
};
export default reduceReducers;
